import { registerApi as api } from '../../api';

// export const uploadEmployeeMaster = async (fileData) => {
//   try {
//     const formData = new FormData();
//     formData.append('file', fileData);
//     const token = sessionStorage.getItem('token');
//     const selectedClientID = sessionStorage.getItem('selectedClient')
//     const response = await api.post('/upload_employee_master', formData, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'multipart/form-data'
//       },
//       params : {
//           'selectedClientID' : selectedClientID
//       }
//     });
//     return response.data;
//   } catch (error) {
//     throw error.response ? error.response.data.error : error.message;
//   }
// };


export const uploadEmployeeMaster = async (fileData) => {
  try {
    const formData = new FormData();
    formData.append('file', fileData);
    const token = sessionStorage.getItem('token');
    const selectedClientID = sessionStorage.getItem('selectedClient')
    const response = await api.post('/upload_employee_master', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      params: {
        selectedClientID: selectedClientID
      },
      timeout: 120000 // 2 minutes for large employee master uploads (1500+ rows)
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};



export const fetchEmployees = async (current_month) => {
  try {
    const client_ID = sessionStorage.getItem('selectedClient')
    const token = sessionStorage.getItem('token');
    const response = await api.get(`/get_employee_master/${current_month}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      params: {
        client_id: client_ID,
        ...(sessionStorage.getItem('selectedUnit')
          ? { unit_id: sessionStorage.getItem('selectedUnit') }
          : {}),
      }
    }
    );
    const payload = response?.data;
    if (Array.isArray(payload)) return payload;
    if (Array.isArray(payload?.data)) return payload.data;
    if (Array.isArray(payload?.employees)) return payload.employees;
    return [];
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const getReportsOfEmployeeBranchTransfer = async (current_month, client_id, unit_id = null) => {
  try {
    const token = sessionStorage.getItem('token');
    const params = { client_id };
    if (unit_id) {
      params.unit_id = unit_id;
    }
    const response = await api.get(`/get_reports_of_Employee_Branch_Transfer/${current_month}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data.error || error.response.data.message || error.message;
    }
    throw error.message;
  }
};

export const getEmployeeImportantBackupReport = async (current_month, client_id, unit_id = null) => {
  try {
    const token = sessionStorage.getItem('token');
    const params = { client_id };
    if (unit_id) {
      params.unit_id = unit_id;
    }
    const response = await api.get(`/get_employee_important_backup_report/${current_month}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params,
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data.error || error.response.data.message || error.message;
    }
    throw error.message;
  }
};

export const fetchEmployeesByClient = async (current_month, client_id, unit_id = null) => {
  try {
    const token = sessionStorage.getItem('token');
    const params = { client_id };
    if (unit_id) {
      params.unit_id = unit_id;
    }
    const response = await api.get(`/get_employee_master/${current_month}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      params,
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data.error || error.response.data.message || error.message;
    }
    throw error.message;
  }
};

export const fetchEmployeesByClientAll = async (client_id, unit_id = null) => {
  try {
    const token = sessionStorage.getItem('token');
    const params = { client_id };
    if (unit_id) params.unit_id = unit_id;
    const response = await api.get('/get_employee_master_all', {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      params,
    });
    return response.data;
  } catch (error) {
    if (error.response?.data) {
      throw error.response.data.error || error.response.data.message || error.message;
    }
    throw error.message;
  }
};

export const updateEmployees = async (id, employeesData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update_employee_master/${id}`, employeesData, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const deleteEmployees = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete_employee_master/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const multiDeleteEmployeeMaster = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/delete_multiple_EmployeeMaster', ids, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const fetchEmployeeDynamicUpdateFields = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get('/employee_dynamic_update_fields', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const downloadEmployeeDynamicUpdateTemplate = async (payload) => {
  try {
    const token = sessionStorage.getItem('token');
    const selectedClientID = sessionStorage.getItem('selectedClient');
    const response = await api.post('/employee_dynamic_update_template', payload, {
      responseType: 'blob',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      params: {
        selectedClientID
      }
    });
    return response;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const uploadEmployeeDynamicUpdate = async (fileData) => {
  try {
    const formData = new FormData();
    formData.append('file', fileData);
    const token = sessionStorage.getItem('token');
    const selectedClientID = sessionStorage.getItem('selectedClient');
    const response = await api.post('/upload_employee_dynamic_update', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
      params: {
        selectedClientID
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};

export const postEmployeeTransfer = async (payload) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/employee_transfer', payload, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

/** Undo the latest branch/org transfer for this employee (matches current branch in history). */
export const postEmployeeTransferRevert = async (payload) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/employee_transfer_revert', payload, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const uploadEmployeeBulkTransfer = async (fileData, client_id, current_month) => {
  try {
    const formData = new FormData();
    formData.append('file', fileData);
    const token = sessionStorage.getItem('token');
    const response = await api.post('/upload_employee_bulk_transfer', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
      params: {
        client_id,
        current_month,
      },
      timeout: 120000,
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : error.message;
  }
};

export const downloadEmployeeBulkTransferTemplate = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get('/download_employee_bulk_transfer_template', {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
      responseType: 'blob',
    });
    return response;
  } catch (error) {
    throw error.response ? error.response.data?.error || error.message : error.message;
  }
};
